<template>
  <div class="wrap personal-wrap flex-column">
    <div class="flex-item">
      <div class="grid-tip tip">
        快来取个有逼格的名字吧~
      </div>
      <ul class="edit">
        <li class="user-order-title">
          <p>
            <label>昵称</label>
            <input class="right" placeholder="请输入昵称" v-model="nickName" />
          </p>
        </li>
      </ul>
      <div class="editButton">
        <mu-raised-button label="保存" fullWidth primary @click="save()" />
      </div>
    </div>
    <!-- <menus></menus> -->
    <mu-toast v-if="toast" message="昵称不能为空  *__*" class="custom-toast" />
    <mu-toast v-if="successMsg" message="修改成功!" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      nickName: '',
      toast: false, //提示文字为空
      successMsg: false, //修改成功
    }
  },

  methods: {
    ...mapActions({
      doSetNickName: 'doSetNickName', //设置会员昵称api
    }),
    save() {
      if (this.nickName == '' || this.nickName == null) {
        this.nickName = '';
        this.toast = true;
        setTimeout(() => { this.toast = false }, 1500)
      } else {
        this.itDoSetNickName(this.nickName);
        this.$router.push({
          path: '/main/userinfo'
        })
      }
    },
    //设置会员昵称api
    itDoSetNickName(nickName) {
      this.doSetNickName(nickName).then(res => {
        this.successMsg = true;
        setTimeout(() => { this.successMsg = false }, 1500);
      }).catch(error => {
        console.log(error);
      })
    },
  },
  components: {
    menus
  },
  created() {
    if (this.$route.query.nickName == 'null') {
      this.nickName = '';
      return;
    } else if (this.$route.query.nickName != 'null') {
      this.nickName = this.$route.query.nickName;
    }
  },
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';

</style>



// WEBPACK FOOTER //
// editnickname.vue?457280b8